// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"67":"511f7bc9","166":"29d0937a"}[chunkId] + ".chunk.css";
};